if (!customElements.get('enough-design')) {
  customElements.define('enough-design', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const root = this;
      const find = selector => root.querySelector(selector);
      const setStatus = message => {
        const status = find('#share-status');
        if (status) status.textContent = message;
      };
      const reminders = [
        'You don\u2019t have to earn your enoughness.',
        'Your feelings deserve a little kindness.',
        'You can begin again, as often as you need.',
        'You are allowed to take a breath.',
        'You belong, just as you are.',
        'Small moments of care matter.'
      ];
      let current = 0;
      const affirmation = find('#affirmation');
      find('#new-reminder')?.addEventListener('click', () => {
        if (!affirmation) return;
        current = (current + 1) % reminders.length;
        affirmation.textContent = reminders[current];
        setStatus('');
      });

      const needs = {
        encouragement: ['You don\u2019t have to earn your enoughness. There is room for you, however today feels.', '/pages/parents', 'Explore a little space for you'],
        feelings: ['Big feelings can have room here. Words, quiet company, or space may each feel welcome.', '/pages/parents', 'Explore being alongside your child'],
        classroom: ['There is room for each child to share, draw, listen\u2014or pass. No one needs to feel a certain way.', '/pages/teachers', 'Explore the classroom invitation']
      };
      root.querySelectorAll('[data-need]').forEach(button => {
        button.addEventListener('click', () => {
          const choice = needs[button.dataset.need];
          if (!choice) return;
          root.querySelectorAll('[data-need]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          const [copy, url, label] = choice;
          const text = find('#need-copy');
          const link = find('#need-resource');
          if (text) text.textContent = copy;
          if (link) {
            link.href = url;
            link.textContent = label;
          }
        });
      });

      async function makeCard() {
        if (!affirmation) throw new Error('Reminder text is unavailable');
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1080;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('Unable to create card');
        context.fillStyle = '#b7ddf8';
        context.fillRect(0, 0, 1080, 1080);
        context.strokeStyle = '#172943';
        context.lineWidth = 3;
        context.strokeRect(50, 50, 980, 980);
        context.fillStyle = '#172943';
        context.textAlign = 'center';
        context.font = '700 24px Arial';
        context.fillText('A LITTLE REMINDER FOR YOU', 540, 170);
        context.font = '58px Georgia';
        const words = affirmation.textContent.trim().split(/\s+/);
        const lines = [];
        let line = '';
        for (const word of words) {
          const next = line ? line + ' ' + word : word;
          if (context.measureText(next).width > 820 && line) {
            lines.push(line);
            line = word;
          } else {
            line = next;
          }
        }
        if (line) lines.push(line);
        const top = 460 - (lines.length - 1) * 42;
        lines.forEach((text, index) => context.fillText(text, 540, top + index * 84));
        if (root.dataset.logo) {
          const logo = new Image();
          logo.crossOrigin = 'anonymous';
          logo.src = root.dataset.logo;
          try {
            await logo.decode();
            const height = 170 * logo.height / logo.width;
            context.drawImage(logo, 455, 745, 170, height);
          } catch {
            // The reminder can still be downloaded if the logo fails to load.
          }
        }
        context.font = '22px Arial';
        context.fillText('theenoughcompany.ca', 540, 950);
        return new Promise((resolve, reject) => {
          canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Unable to create card')), 'image/png');
        });
      }

      function download(blob) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'enough-reminder.png';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }
      find('#download-card')?.addEventListener('click', async () => {
        try {
          download(await makeCard());
          setStatus('Your reminder card is ready to save.');
        } catch {
          setStatus('Unable to create the card. Please try again.');
        }
      });
      find('#share-card')?.addEventListener('click', async () => {
        try {
          const blob = await makeCard();
          const file = new File([blob], 'enough-reminder.png', {type: 'image/png'});
          const text = affirmation.textContent.trim();
          if (navigator.canShare?.({files: [file]})) {
            await navigator.share({files: [file], title: 'A little reminder from Enough', text});
          } else if (navigator.share) {
            await navigator.share({title: 'A little reminder from Enough', text, url: location.origin});
          } else {
            download(blob);
            setStatus('Your card is ready to save and share.');
          }
        } catch (error) {
          if (error.name !== 'AbortError') setStatus('Sharing isn\u2019t available here. Use Download card instead.');
        }
      });

      const boxes = find('#box-count');
      const quote = find('#order-quote');
      const total = find('#order-total');
      function updateOrder() {
        if (!boxes || !quote) return;
        const count = Number(boxes.value);
        const valid = Number.isInteger(count) && count >= 1 && count <= 1000;
        if (total) {
          total.textContent = valid
            ? `${count.toLocaleString()} ${count === 1 ? 'box' : 'boxes'} \u00b7 ${(count * 100).toLocaleString()} individually wrapped bandages`
            : 'Please choose a whole number of boxes from 1 to 1,000.';
        }
        quote.setAttribute('aria-disabled', String(!valid));
        quote.href = valid
          ? 'mailto:andrea@enoughcompany.ca?subject=' + encodeURIComponent('School bandage quote \u2014 ' + count + ' boxes') + '&body=' + encodeURIComponent('Hi Andrea,\n\nPlease send current pricing and delivery details for ' + count + ' boxes (' + (count * 100).toLocaleString() + ' bandages).\n\nSchool name:\nDelivery postal code:\nWhen needed:\n\nThank you!')
          : '#school-order';
      }
      boxes?.addEventListener('input', updateOrder);
      quote?.addEventListener('click', event => {
        if (quote.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
      updateOrder();

      find('#booking-form')?.addEventListener('submit', event => {
        event.preventDefault();
        const type = find('#visit-type')?.value || 'A conversation';
        const date = find('#visit-date')?.value || 'Flexible';
        const message = find('#visit-message')?.value.trim() || '';
        const body = 'Hi Andrea,\n\nI\u2019m interested in: ' + type + '\nPreferred date: ' + date + '\n\n' + message + '\n\nCould you share availability and pricing?\n\nThank you!';
        const url = 'mailto:andrea@enoughcompany.ca?subject=' + encodeURIComponent(type + ' enquiry') + '&body=' + encodeURIComponent(body);
        const fallback = find('#booking-fallback');
        if (fallback) {
          fallback.href = url;
          fallback.hidden = false;
        }
        const status = find('#booking-status');
        if (status) status.textContent = 'Your draft is ready. Send it from your email app to request a time. Andrea will confirm availability.';
        location.href = url;
      });
    }
  });
}